import React from 'react';
import { Outlet } from 'react-router-dom';
import { Typography } from 'antd';

const { Title } = Typography;

const Help: React.FC = () => {
  return (
    <div className="p-6">
      <Title level={2}>Help & Support</Title>
      <Outlet />
    </div>
  );
};

export default Help; 